import React , { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
// import CharFadeText from "../Animation/CharFadeText";

const Home = ({ handleChecked, checkAssets, handleGia, routeChangeManual, loader }) => {
    const giaRef = useRef(null);
  const manualRef = useRef(null);
  const [active, setActive] = useState("gia");

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev === "gia" ? "manual" : "gia"));
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (loader) return;
    const currentGia = giaRef.current;
    const currentManual = manualRef.current;
    currentGia?.classList.remove("char-shimmer");
    currentManual?.classList.remove("char-shimmer");

    // Force reflow to restart animation
    void currentGia?.offsetWidth;
    void currentManual?.offsetWidth;

    if (active === "gia") {
      currentGia?.classList.add("char-shimmer");
    } else {
      currentManual?.classList.add("char-shimmer");
    }
  }, [active, loader]);
  
  

  return (
    <div className="start-pricing-form w-100 gap-4 start-pricing-buttons build_price_toggle bg-transparent">
      <div className="tab-btns-wrapper">
        <input
          className="single-pair-check"
          type="checkbox"
          id="checkbox_toggle"
          onChange={handleChecked}
          checked={!checkAssets}
        />
        <div className="single-pair-checkbox build-pair-checkbox">
          <label htmlFor="checkbox_toggle" className="single-pair-slide">
            <label
              htmlFor="checkbox_toggle"
              className="single-pair-toggle"
            ></label>
            <label
              htmlFor="checkbox_toggle"
              className={`single-pair-text ${
                checkAssets  ? "single" : ""
              }`}
            >
              Basic
            </label>
            <label
              htmlFor="checkbox_toggle"
              className={`single-pair-text 
              ${!checkAssets  ? "pair" : ""}`}
            >
              Advanced
            </label>
          </label>
        </div>
      </div>

      {/* <div className="pricing-userlogin-content-btn w-100 gia-text">
        <Button onClick={handleGia} disabled={loader} className={loader  ? "cursor-not-allowed" : ""}> <span ref={giaRef} className={`${loader ? "" : "char-shimmer"}`}>I have a GIA</span></Button>
      </div>
      <div className="pricing-userlogin-content-btn w-100  ">
        <Button onClick={routeChangeManual} disabled={loader} className={loader  ? "cursor-not-allowed" : ""}><span ref={manualRef} className={`${loader  ? "" : "char-shimmer"}`}>Manual</span></Button>
      </div> */}
         <div className="pricing-userlogin-content-btn w-100 gia-text">
        <Button onClick={handleGia} disabled={loader} className={loader  ? "cursor-not-allowed" : ""}>I have a GIA</Button>
      </div>
      <div className="pricing-userlogin-content-btn w-100  ">
        <Button onClick={routeChangeManual} disabled={loader} className={loader  ? "cursor-not-allowed" : ""}>Manual</Button>
      </div>

  
    </div>
  );
};

export default Home;
